import { ANNOTATION_SELECT_STYLE } from "src/domains/shared/constants/annotationSelectStyle";
import { ANNOTATION_FILL_ALPHA } from "src/domains/shared/constants/annotationFillStyle";

export const ANNOTATION_COLOR = {
  RED: {
    fill: (opacity: number) => `rgba(248, 7, 1, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(248, 7, 1, ${opacity})`,
  },
  YELLOW: {
    fill: (opacity: number) => `rgba(255, 254, 0, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(255, 254, 0, ${opacity})`,
  },
  GREEN: {
    fill: (opacity: number) => `rgba(30, 128, 0, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(30, 128, 0, ${opacity})`,
  },
  SKYBLUE: {
    fill: (opacity: number) => `rgba(135, 206, 235, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(135, 206, 235, ${opacity})`,
  },
  BLUE: {
    fill: (opacity: number) => `rgba(2, 26, 255, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(2, 26, 255, ${opacity})`,
  },
  BROWN: {
    fill: (opacity: number) => `rgba(165, 42, 42, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(165, 42, 42, ${opacity})`,
  },
  ROYAL_BLUE: {
    fill: (opacity: number) => `rgba(65, 105, 225, ${ANNOTATION_FILL_ALPHA * opacity})`,
    stroke: (opacity: number) => `rgba(65, 105, 225, ${opacity})`,
  },
  SELECT: {
    fill: () => ANNOTATION_SELECT_STYLE.fill,
    stroke: () => ANNOTATION_SELECT_STYLE.stroke,
  },
};
